import { Directive, effect, inject, input } from '@angular/core'
import { MatButton } from '@angular/material/button'

@Directive({
  selector: 'button[matButton][libSubmitBtn], button[mat-button][libSubmitBtn]',
  host: {
    class: 'lib-submit-button',
  },
})
export class SubmitBtnDirective {
  private readonly matButton = inject(MatButton, { self: true })

  readonly valid = input.required<boolean>()

  private readonly applyButtonStyle = effect(() => {
    this.matButton.appearance = this.valid() ? 'filled' : 'text'
  })
}
